export default __webpack_public_path__ + "static/media/shoes.56eea718.png";